export const MyReportsRequest = 'MyReportsRequest';
export const GET_MY_REPORTS_DATA = 'GET_MY_REPORTS_DATA';
export const GET_MY_REPORTS_DAY_DATA = 'GET_MY_REPORTS_DAY_DATA';
